import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

import './ButtonCard.scss';

export default function ButtonCardWithFunction(props) {

  const color = props.color || 'primary';
  const onClick = props.onClick || function () { };

  if (props.isFromHomePage) {
    return (
      <div className={`button-card button-card-review d-flex justify-content-center align-items-center`}>
        <Button type="submit" onClick={onClick} variant="contained" color={color} className={`${color === 'primary' ? "primary-button" : ''} ${props.className}`}>
          <div className='d-flex justify-content-center align-items-center flex-column'>{props.icon}<span className='name-text'>{props.name}</span></div>
        </Button>
      </div >
    )
  }
  else {
    return (
      <div className={`button-card button-card-fn shadow-sm d-flex justify-content-center align-items-center`}>
        <Button type="submit" onClick={onClick} variant="contained" color={color} className={`${color === 'primary' ? "primary-button" : ''} ${props.className}`}>{props.icon}<span className="name text-center">{props.name}</span></Button>
      </div >
    )
  }
}

ButtonCardWithFunction.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  icon: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};
